module.exports = __webpack_public_path__ + "fonts/NanumSquare.ca0ec81b.woff";